import React, { useEffect, useState, useContext } from "react";
import { useUnidades } from "../../hooks/test/useUnidades";
import { Loader } from "../../components/Loader";
import { AddEdo } from "../../components/customComponents/Modals/AddEdo.js";
import useCeo from "../../hooks/useCEO";
import ReactPaginate from 'react-paginate';
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faTableList,
    // faPenToSquare
} from "@fortawesome/free-solid-svg-icons";

export const AdministracionStatusEnRuta = ({

}) => {
    //---------------------TITULO DE LA PÁGINA---------------------\\
    useCeo({
        title: "Administracion de los estatus en ruta",
        description: "Página de estatus de unidades en ruta",
    });

    //---------------------CONSTANTES Y FUNCIONES---------------------\\
    const {
        postEstatus,
        getListaEstatus,
        patchEstatus
    } = useUnidades();
    const [listaEstatus, setListaEstatus] = useState([]);   //lista de la tabla 
    const [loading, setLoading] = useState(false);          //sirve para cargar los datos de la página
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal(true);       // Función para abrir el modal
    const handleCloseModal = () => setShowModal(false);     // Función para cerrar el 

    const [currentPage, setCurrentPage] = useState(1);      // Estado para la página actual
    const [pageSize, setPageSize] = useState(10);           // Estado para el tamaño de página
    const [totalItems, setTotalItems] = useState(0);        // Estado para el total de items

    const edo_alert = async (event, estatusId) => {
        const isChecked = event.target.checked;
        const nuevoCancelValue = isChecked ? 0 : 1;
        // console.log("Estado alert function called for estatusId:", estatusId);
        if (!isChecked) { // Checkbox se desmarca (se va a INACTIVAR)
            Swal.fire({
                icon: "warning",
                title: `¿Esta seguro de actualizar el estatus a INACTIVO?`,
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),

            }).then(async (result) => {
                if (result.isConfirmed) {
                    const updatedListaEstatusOptimista = listaEstatus.map(item =>
                        item.status_id === estatusId ? { ...item, cancel: nuevoCancelValue } : item);
                    setListaEstatus(updatedListaEstatusOptimista);
                    setLoading(true);
                    try {
                        const respPut = await patchEstatus(estatusId);
                        if (respPut.ok) {
                            // console.log(`Estatus con ID: ${estatusId} actualizado a INACTIVO exitosamente.`);
                            toast.success("Estatus actualizado correctamente");
                            fetchData(currentPage, pageSize);


                        } else {
                            fetchData(currentPage, pageSize);
                            // console.error("Error al actualizar estatus:", respPut);
                            Swal.fire({
                                icon: 'error',
                                title: 'Error al actualizar',
                                text: respPut.msg || 'No se pudo actualizar el estatus. Inténtalo de nuevo.',
                            });
                        }
                    } catch (error) {
                        fetchData(currentPage, pageSize);
                        // console.error("Error de red al actualizar estatus:", error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de red',
                            text: 'No se pudo conectar con el servidor para actualizar el estatus. Verifica tu conexión a internet.',
                        });
                    } finally {
                        setLoading(false);
                    }
                } else {
                    // console.log(`Cancelado, no se actualizó el estatus con ID: ${estatusId}`);
                    event.target.checked = !isChecked; // Revertir el checkbox en la UI.
                }
            })
        } else { // Checkbox se marca (se va a ACTIVAR)
            Swal.fire({
                icon: "warning",
                title: `¿Desea REACTIVAR el estatus?`,
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const updatedListaEstatusOptimista = listaEstatus.map(item =>
                        item.status_id === estatusId ? { ...item, cancel: nuevoCancelValue } : item
                    );
                    setListaEstatus(updatedListaEstatusOptimista);
                    setLoading(true);
                    try {
                        const respPut = await patchEstatus(estatusId);
                        if (respPut.ok) {
                            // console.log(`Estatus con ID: ${estatusId} actualizado a ACTIVO exitosamente.`);
                            toast.success("Estatus actualizado correctamente");

                        } else {
                            // console.error("Error al actualizar estatus:", respPut);
                            Swal.fire({
                                icon: 'error',
                                title: 'Error al actualizar',
                                text: respPut.msg || 'No se pudo actualizar el Eetatus. Inténtalo de nuevo.',
                            });
                        }
                    } catch (error) {
                        // console.error("Error de red al actualizar estatus:", error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de red',
                            text: 'No se pudo conectar con el servidor para actualizar el estatus. Verifica tu conexión a internet.',
                        });
                    } finally {
                        setLoading(false);
                    }
                } else {
                    console.log(`Cancelado, no se activó el estatus con ID: ${estatusId}`);
                    event.target.checked = !isChecked; // Revertir el checkbox en la UI.
                }
            })
        }
    }

    const fetchData = async (page = 1, pageSize = 10) => {         //carga los datos de ta tabla
        // console.log("fetchData se está ejecutando... Página: ${page}, Tamaño de página: ${pageSize}"); // <--- AGREGAR ESTE LOG
        setLoading(true);
        try {
            const resp = await getListaEstatus(page, pageSize);
            // console.log("Respuesta de getListaEstatus:", resp); // <-- LOG AÑADIDO
            if (resp.ok) {
                setListaEstatus(resp.estatus);
                console.log("Lista de estatus actualizada:", listaEstatus); // <-- LOG AÑADIDO
                setTotalItems(resp.total);

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error al cargar los estatus",
                    text: resp.msg || "Error desconocido al obtener la lista de estatus.",
                    timer: 4000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "warning",
                title: "Error de conexión",
                text: "No se pudo conectar con el servidor para obtener la lista de estatus.",
                timer: 4000,
                showConfirmButton: false,
            });
        } finally {
            setLoading(false);
        }
    }

    const refreshEdo = () => {
        fetchData(currentPage, pageSize);
    };

    const handlePageClick = (event) => {
        const newPage = event.selected + 1;
        // console.log("handlePageClick ejecutándose. Página seleccionada:", event.selected, "Nueva página:", newPage); // <-- LOG AÑADIDO
        setCurrentPage(newPage);
        // console.log("setCurrentPage llamado con:", newPage, ".  currentPage AHORA debería ser:", newPage); // <-- LOG DESPUÉS de setCurrentPage

    };

    // Calcular los items para la página actual usando slice
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const currentEstatus = listaEstatus.slice(startIndex, endIndex);


    useEffect(() => {           //llama la info de la tabla
        // console.log("useEffect ejecutándose. Página actual:", currentPage, "Tamaño de página:", pageSize); // <-- LOG AÑADIDO
        fetchData(currentPage, pageSize);
    }, [currentPage, pageSize]);


    //---------------------JSX---------------------\\
    return (
        <>
            {loading && <Loader />}

            <div className=" container">
                <div className="row">
                    <div className="d-flex justify-content-center p-2">
                        <FontAwesomeIcon  //agtegar icono para agregar nuevo Estatus 
                            icon={faTableList}
                            className="fa-2x text-dark pb-2 mr-2 cursor"
                            onClick={handleShowModal}
                            title="Agregar estatus"
                        />
                        <FontAwesomeIcon
                            icon={faPlus}
                            className="fa text-success pb-2 mr-2 cursor"
                            onClick={handleShowModal}
                            title="Agregar estatus"
                        />
                    </div>

                    <div className="administracion-status-table-container">
                        <table className="table table-responsive-md status-table">
                            <thead className=" table-secondary">
                                <tr>
                                    <th scope="col"><div className="text-center">No.</div></th>
                                    <th scope="col"><div className="text-center">Icono</div></th>
                                    <th scope="col"><div>Nombre de estatus</div></th>
                                    <th scope="col"><div className="text-center">Estado</div></th>
                                </tr>
                            </thead>
                            <tbody className=" table-light">
                                {currentEstatus.map((item, index) => (
                                    <tr key={item.status_id}> {/* Se usa estatus_id para la key */}
                                        <th scope="row"><div className="text-center">{(currentPage - 1) * pageSize + index + 1}</div></th> {/* Enumeración */}
                                        <td className="text-center"><i
                                            className={
                                                item.icon
                                                    ? item.icon
                                                    : "fa-solid fa-question"
                                            }
                                            style={{
                                                backgroundColor: item.color,
                                                borderRadius: "3rem",
                                                paddingTop: "5px",
                                                height: 30,
                                                width: 30,
                                            }}
                                            // title={item.notas}
                                        >
                                        </i></td> {/* Mostrar icono */}
                                        <td><div>{item.nombre}</div></td> {/* Display nombre */}
                                        <td className=" text-center"><div className="form-switch">
                                            <div htmlFor="flexSwitchCheckDefault">
                                                <input
                                                    className="form-check-input azul-tp"
                                                    type="checkbox"
                                                    role="switch"
                                                    aria-checked="false"
                                                    name={`estado-${item.estatus_id}`}
                                            checked={item.cancel == 0}
                                            onChange={(e) => edo_alert(e, item.status_id)}
                                            id={`flexSwitchCheckDefault-${item.estatus_id}`}
                                            // defaultChecked={!item.cancel}
                                        />
                                        </div>
                                </div></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* PAGINACIÓN */}
                <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3} //  Cantidad de números de página a mostrar
                        marginPagesDisplayed={1} // Cantidad de páginas a mostrar en los márgenes
                        pageCount={Math.ceil(totalItems / pageSize)} // Calcula el total de páginas
                        renderOnZeroPageCount={null}
                        previousLabel="<"
                        containerClassName="pagination"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                    />
                </div>
            </div>
            </div>
            <AddEdo
                show= {showModal}
                handleClose= {handleCloseModal}
                onEdoSaved={refreshEdo}
            />
        </>
    )

}